<template functional>
  <div class="flex">
    <h3 class="title-wrapper">
      <span class="title">{{ props.title }}</span>
    </h3>
  </div>
</template>

<script>
export default {
  name: 'DecorationTitle',
  props: {
    title: String,
  },
}
</script>

<style lang="scss" scoped>
.title-wrapper {
  position: relative;
  .title {
    z-index: 10;
    position: relative;
    font-size: 34px;
    font-weight: bold;
    color: #282828;
  }

  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0px;
    height: 11px;
    background-color: #b1def4;
  }
}
</style>